/* npm version only adapted from https://github.com/cristiandouce/require-global */
/* eslint-env browser */
import load from 'scriptloader';

/**
 * Expose `requireGlobal`
 */

export default requireg;

/**
 * Load global `source` with optional
 * check for a global `namespace` or many
 *
 * @param {String} source
 * @param {String|Array} namespace
 * @param {Function} callback
 * @public
 */

function requireg(source, namespace, callback) {
  if (typeof namespace === 'function') {
    callback = namespace;
    namespace = null;
  }

  if (loaded(namespace)) return callback(null);

  load(source, callback);
}

/**
 * Check for an already loaded namespace
 * to avoid overriding or double fetching
 *
 * @param {String|Array} namespace
 * @return {Boolean}
 * @private
 */

function loaded(namespace) {
  if (typeof namespace === 'string') namespace = [namespace];

  for (let i = 0; i < namespace.length; i += 1) {
    const test = new Function('_', `return _.${namespace[i]} != null`);

    try {
      if (!test(window)) return false;
    } catch (err) {
      return false;
    }
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/modules/npm-component/require-global.js